import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { MetaLayout } from '@/@vxapp/@Enums/MetaLayout'
import { A } from '@/@vxapp/@Enums/PHP/Auth/DataProviders/AbilityAction'

export const AccessPageMeta = {
  Projects: {
    preview: {
      ...PageMeta.Projects.preview,
      meta: { ...PageMeta.Projects.preview.meta, subject: 'Jobs', action: A.READ },
    },
    Add: { Meta: { subject: 'Jobs', action: A.CREATE } },
  },
  MicrosoftOAuth: {
    Settings: {
      ...PageMeta.MicrosoftOAuth.Settings,
      Meta: {
        ...PageMeta.MicrosoftOAuth.Settings.Meta,
        subject: 'OAuth:Microsoft:Status',
        action: A.READ,
      },
    },
  },
  MetaInstagram: {
    Meta: {
      subject: 'OAuth:Meta:Instagram:Status',
      action: A.READ,
      layout: MetaLayout.Default,
    },
  },
  GoogleConnection: {
    Name: 'setup-google-connection',
    Title: 'Google account',
    Icon: 'tabler-brand-google',
    Meta: { subject: 'OAuth:Google:Status', action: A.READ },
  },
  GoogleOAuth: {
    Name: 'setup-google-oauth',
    Title: 'Google connection',
    Meta: { layout: 'blank', publicCallback: 'google' },
  },
} as const
